<app-popup-content *ngIf="isOpen && template">
  <ng-container *ngTemplateOutlet="template">
  </ng-container>
</app-popup-content>